// extracted by mini-css-extract-plugin
export default {"article":"index-module--article--a8e9d","headline":"index-module--headline--3c98d"};